module.exports = __webpack_public_path__ + "img/web3.34b3241c.png";